export { default as ar } from "./ar";
export { default as de } from "./de";
export { default as en } from "./en";
export { default as es } from "./es";
export { default as fr } from "./fr";
export { default as it } from "./it";
